export const ADMINISTRATOR_ROLE_ID = 1;
export const USERS_ADMIN_ROLE_ID = 2;
export const KDAS_ADMIN_ROLE_ID = 3;

export const UnmannedWeigherGUID = '{D37FF0D5-7F0E-4521-AF1E-9D72CE9475C4}';

export enum UserTypeValues {
  PlatformOwner = 1,
  Collector = 2,
  CollectorDriver = 3,
  WasteReceptionPoint = 4, // Σημείο Παραλαβής Αποβλήτων
  CollectionPoint = 5, // Σημεία Συλλογής με username & password
  Contributor = 6,
  WebUser = 7, // Σημεία Συλλογής Χωρίς username & password Αλλά με ΑΦΜ entry
  Ministry = 8, // Υπουργείο
  Public = 9, // Κοινό (κουπόνια)
}

// IDOC
export enum IdocWasteOriginTypes {
  PrimaryStorage = 1,
  SecondaryStorage = 2,
}

export enum IdocWasteDestinationTypes {
  SecondaryStorage = 1,
  Recycling = 2,
}

export enum ContributionStates {
  Empty = 1, // Νέα Εγγραφή
  Draft = 2, // Προσωρινά Αποθηκευμένη
  Saved = 3, // Οριστικοποιημένη
}

export enum ContributionSeries {
  Initial = 1, // Αρχική
  Complementary = 2, // Συμπληρωματική
  Corrective = 3, // Διορθωτική
}

export enum ContributorGroups {
  Plain = 1, // Εισφορείς
  Edoe = 2, // Εισφορείς ΕΔΟΕ
  EdoeUsed = 3, // Εισφορείς ΕΔΟΕ Μεταχειρισμένα
}

// // Σειρές Αρίθμησης
// export enum NumberingSeries {
//   IDocs = 101, // Έντυπα Αναγνώρισης
//   FinDisp = 102, //Δελτία Αποστολής
//   Order = 103, // Εντολή για Re Battery
//   VehRoutes = 104, // Δρομολόγια Οχημάτων
// }

// Σειρές Αρίθμησης
export enum NumberingSeries {
  IDocs = 101, // Έντυπα Αναγνώρισης
  Collections = 102, // Συλλογές
  ContainerOrders = 103, // Παραγγελίες Κάδων
  Order = 105, // Αίτημα Συλλογής
  VehRoutes = 104, // Δρομολόγια Οχημάτων
  ITrans = 106, // Εσωτερικές Μετακινήσεις
  Production = 107, // Παραγωγή
}

// Δρομολόγια
export enum RouteStates {
  Planned = 1, // Προγραμματισμένο
  Executed = 2, // Ολοκληρωμένο
}
export enum RouteLinesStates {
  Planned = 1, // Προγραμματισμένο
  Executed = 2, // Ολοκληρωμένο
}

/* Αιτήματα Συλλογής
 */
export enum CollectionOrderStates {
  NotRouted = 1,
  Routed = 2,
  Executed = 3,
  // Re Battery Liion specific states
  TemporarySaved = 0,
  ApplicationSubmitted = 4,
  /** Fotokiklosi: Παραληφθείσα από Οδηγό (ίδιο value με ApplicationSubmitted) */
  CollectedByDriver = 4,
  ApplicationRejected = 5,
  OrganizationCompleted = 6,
  PackageShipmentCompleted = 7,
  CollectorOrder = 8,
  ScheduledCollectorCollection = 9,
}

export enum CollectionOrderActions {
  TemporarySaved = 1,
  ApplicationSubmitted = 2,
  ApplicationRejected = 3,
  OrganizationCompleted = 4,
  PackageShipmentCompleted = 5,
  CollectorOrderCreated = 6,
  ScheduledCollectorCollectionDefined = 7,
  StatusChangedManually = 8,
}

/* Αιτήματα recordedBy */
export enum CollectionOrderRecordedByStates {
  Mannually = 1,
  IVR = 2,
  WEB = 3,
}
/* Αιτήματα originatedFrom */
export enum CollectionOrderOriginatedFromStates {
  CollectionPoint = 1,
  PlatformUser = 2,
  CollectorUser = 3,
}

// Alarm Types
export enum AlarmTypeValues {
  RouteDuration = 1, // Διάρκεια δρομολογίου
  CollectionVehicle = 2, // Όχημα που εκτελεί την συλλογή/μεταφορά
  CollectionDriver = 3, // Οδηγός που εκτελεί την συλλογή/μεταφορά
  CollectorArea = 4, // Γεωγραφική εμβέλεια δραστηριοποίησης του συλλέκτη/μεταφορέα
  VehicleLoad = 5, // Ωφέλιμο φορτίο οχήματος
  ComplexRoute = 6, // Σύνθετο δρομολόγιο
  EAEA_Numbering = 7, // Αρίθμηση ΕΑΕΑ
  ADR = 8, // ADR
  CollectionPermit = 9, // Άδεια συλλογής μεταφοράς
  CollectorInsurance = 10, // Ασφαλιστήριο αστικής ευθύνης συλλέκτη
  SAMEE_Agreement = 11, // Συμφωνητικό με ΣΑΜΕΕ
  SAMEE_Certificate = 12, // Πιστοποιητικό του ΣΑΜΕΕ
  SecondaryStorage_AEPO = 13, // ΑΕΠΟ εταιρείας δευτερογενούς αποθήκευσης
  SecondaryStorage_Insurance = 14, // Ασφαλιστήριο αστικής ευθύνης δευτερογενούς αποθήκευσης
  RecyclingCompany_AEPO = 15, // ΑΕΠΟ εταιρείας ανακύκλωσης
  RecyclerInsurance = 16, // Ασφαλιστήριο αστικής ευθύνης ανακυκλωτή
  RecyclerISO = 17, // ISO ανακυκλωτή
}

export const DummyCollectorId = 9000;

// Default τιμές για Αφης Κύπρου
export const afisDefaults = {
  materialId: 1,
  ekaCode: '16-06-01',
  collectorId: 1,
  wastereceptionpointId: 1,
};

// Αιτήσεις Αλλαγής Κάδων
export enum ContainersOrderStates {
  Pending = 1,
  Executed = 2,
}
export enum ContainersOrderTypes {
  NewContainer = 1,
  ReplaceContainer = 2,
}

export enum RouteTypes {
  PrimaryToSecondaryStorage = 1, // Σημείο Πρωτογενούς Παραγωγής -> Δευτερογενής Αποθήκευση
  PrimaryToRecyclingFacility = 2, // Σημείο Πρωτογενούς Παραγωγής -> Εγκατάσταση Ανακύκλωσης
  SecondaryStorageToRecycling = 3, // Σημείο Δευτερογενούς Αποθήκευσης -> Εγκατάσταση Ανακύκλωσης
  SecondaryToSecondaryStorage = 4, // Σημείο Δευτερογενούς Αποθήκευσης -> Άλλο Σημείο Δευτερογενούς Αποθήκευσης
}
